import { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';

import NoContent from './NoContent';
import StoryCardRow from './StoryCardRow';
import Preloader from '../../../Preloader';
import StoryCaughtUp from '../../../StoryCaughtUp';

import withComponentName from '../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const StoryCardLists = forwardRef(({
  presentations, presentationsPageLoad, cardURL,
  isInitialPresentationsCall, newPresentationsLoading,
  hasNextPage, isWatchlists, isSingleTopic,
  scrollDivTop, scrollUpTop, scrollToStart,
  isEsg, showCompanyTag, bigScreen, isIR,
}, ref) => {
  const presentationsListClass = cx('presentations_lists',
    {
      updating_presentations_lists: presentationsPageLoad,
      watchlists: isWatchlists && (!isEsg || !isIR),
      esg: isEsg,
      ir: isIR,
      big_screen: bigScreen,
    });

  return (
    <div className={presentationsListClass} ref={ref}>
      {!presentations.length && isInitialPresentationsCall && !presentationsPageLoad
        ? (<NoContent />)
        : null}

      {presentations.map((presentation) => (
        <StoryCardRow
          key={presentation.id}
          {...presentation}
          cardURL={cardURL}
          isWatchlists={isWatchlists}
          isSingleTopic={isSingleTopic}
          isEsg={isEsg}
          isIR={isIR}
          showCompanyTag={showCompanyTag}
          hasBigScreenDesign={bigScreen}
        />
      ))}

      {newPresentationsLoading && (
        <Preloader
          loading
          static
          centered
        />
      )}

      {presentations.length && isInitialPresentationsCall && !presentationsPageLoad && !hasNextPage
        ? <StoryCaughtUp hideButton />
        : null}

      <button
        type="button"
        aria-label="scroll-up-button"
        className={cx('scroll-up-button', { hide: !scrollDivTop })}
        onClick={scrollToStart}
        style={{ top: `${scrollUpTop}px` }}
      >
        <FontAwesomeIcon icon={faChevronUp} />
      </button>
    </div>
  );
});

export default withComponentName(StoryCardLists);
